<template>
<span class="p-float-label mb-2 mt-0"   v-show="data.show">

  <Dropdown v-model="inputdata" :disabled="data.disabled" :options="data.options" optionLabel="name"  class="w-full p-inputtext-sm"  :class="{'p-invalid':data.has_error }" @change="emitValue" />

  <label :for="data.key"  :class="{'hidden':data.has_error }">{{data.title}}</label>
  <small :id="data.key+'-help'" class="p-error pt-2" v-if="data.has_error"><b> {{data.title}}</b> {{data.error_message}}</small>
</span>


</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {

  name: 'InputSelectValidate',
  props:["data","fieldindex",],
  data () {
    return {
    	inputdata:[],
    }
  },
  computed:{
  	dataValue()
  	{
  		return this.data.value
  	}
  },
  watch:{
  	dataValue(newVal,oldVal)
  	{
      console.log("InputSelectValidate val change")
      console.log(this.dataValue)
  		this.inputdata = this.dataValue
  	}
  },
  methods:{
  	emitValue()
  	{
      console.log("emit")
      console.log(this.inputdata)
  		this.$emit("emitValue",{value:this.inputdata,index:this.fieldindex})
  	},
  }
};
</script>

<style lang="css" scoped>
</style>